import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-xl-11 col-xxl-9" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "d-flex align-items-center text-danger fst-italic" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "warning", -1)
const _hoisted_6 = { class: "form-content" }
const _hoisted_7 = { class: "email-bcc mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_9 = { class: "email-reply-to mb-4" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "add", -1)
const _hoisted_14 = { class: "row form-buttons d-flex flex-column justify-content-start" }
const _hoisted_15 = { class: "fs-6 mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_17 = { class: "d-inline-block mt-4 pt-4 border-top border-2 border-light" }
const _hoisted_18 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertSuccess = _resolveComponent("AlertSuccess")!
  const _component_AlertError = _resolveComponent("AlertError")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_input_email = _resolveComponent("input-email")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('emails'),
        "help-text": _ctx.$t('emailsDescription')
      }, null, 8, ["title", "help-text"]),
      _createVNode(_component_AlertSuccess, {
        "show-if": this.savedSuccessfully,
        class: "mt-3"
      }, null, 8, ["show-if"]),
      _createVNode(_component_AlertError, {
        exceptions: this.exceptions,
        class: "mt-3"
      }, null, 8, ["exceptions"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BaseSpinner, {
            spin: !this.isReady
          }, null, 8, ["spin"]),
          (this.isReady && !this.hasEmailSettings)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString('E-mailinstellingen voor deze apotheek zijn nog niet volledig geïnitialiseerd.'), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (this.isReady && this.hasEmailSettings)
            ? (_openBlock(), _createBlock(_component_dp_form, {
                key: 1,
                as: "form",
                onSubmit: this.submitData,
                novalidate: ""
              }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("section", _hoisted_7, [
                      _createElementVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('replyTo')) + " ", 1),
                        _hoisted_8
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('replyToDescription')), 1),
                      _createVNode(_component_input_email, {
                        modelValue: this.nvpOrderNotificationEmailReplyTo.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.nvpOrderNotificationEmailReplyTo.value) = $event)),
                        modelModifiers: { trim: true },
                        label: _ctx.$t('email'),
                        name: "emailReplyTo",
                        class: "w-50",
                        errors: errors,
                        rules: "required|max:100"
                      }, null, 8, ["modelValue", "label", "errors"])
                    ]),
                    _createElementVNode("section", _hoisted_9, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('newOrderNotification')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('newOrderNotificationDescription')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bccEmails, (email, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "d-flex align-items-end w-50 mb-2"
                        }, [
                          _createVNode(_component_input_email, {
                            modelValue: this.bccEmails[index],
                            "onUpdate:modelValue": ($event: any) => ((this.bccEmails[index]) = $event),
                            modelModifiers: { trim: true },
                            label: _ctx.$t('email'),
                            name: 'emailBcc' + index,
                            class: "flex-grow-1",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "errors"]),
                          (this.bccEmails.length > 1)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-icon btn-danger ms-2 mb-3",
                                onClick: ($event: any) => (this.removeBccEmail(index))
                              }, _hoisted_12, 8, _hoisted_10))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-primary",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.addBccEmail && this.addBccEmail(...args)))
                      }, [
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('required')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.$t('save')), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}